import { render, staticRenderFns } from "./select-project-group-game.vue?vue&type=template&id=4cc5aa72&scoped=true"
import script from "./select-project-group-game.vue?vue&type=script&lang=js"
export * from "./select-project-group-game.vue?vue&type=script&lang=js"
import style0 from "./select-project-group-game.vue?vue&type=style&index=0&id=4cc5aa72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5aa72",
  null
  
)

export default component.exports